"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStylesConfig = void 0;
const defaultStylesConfig = {
  classesStyles: {},
  enableCSSInlineProcessing: true,
  enableUserAgentStyles: false,
  idsStyles: {},
  tagsStyles: {},
  baseStyle: {
    fontSize: 14,
    whiteSpace: 'normal'
  }
};
exports.defaultStylesConfig = defaultStylesConfig;
//# sourceMappingURL=defaults.js.map